import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Industries from "./pages/Industries";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
            <Toaster />
          </BrowserRouter>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
